import { RoutineMetadata } from 'hevy-shared';
import { Link } from 'components/Link';
import React from 'react';
import { SecondaryButton } from 'styleguide/Buttons';
import { Card } from 'styleguide/Card';
import { H5, P1, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { modal } from 'components/Modals/ModalManager';
import styled, { ThemeProps } from 'styled-components';
import { FlexRow } from 'styleguide/Row';
import { Theme } from 'styleguide/types';
import { colors } from 'styleguide/colors';
import { t } from 'translations/t';

const RoutineCardContainer = styled(Card)`
  padding: ${Spacing.md}px;
  gap: ${Spacing.md}px;
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'dark' && colors.greyUltraDark};
  border: 1px solid
    ${(props: ThemeProps<Theme>) =>
      props.theme.name === 'light' ? colors.greyUltraLight : colors.greyUltraDark};
`;

export const RoutinesCard = ({ routines }: { routines?: RoutineMetadata[] }) => {
  return !routines || routines?.length === 0 ? (
    <Card style={{ padding: Spacing.lg, gap: Spacing.md }}>
      <FlexRow style={{ justifyContent: 'space-between' }}>
        <FlexRow style={{ gap: Spacing.xs }}>
          <H5>{t('global.routines')}</H5>
          <P2 type="secondary">0</P2>
        </FlexRow>
      </FlexRow>
    </Card>
  ) : (
    <Card style={{ padding: Spacing.lg, gap: Spacing.md }}>
      <FlexRow style={{ justifyContent: 'space-between' }}>
        <FlexRow style={{ gap: Spacing.xs }}>
          <H5>{t('global.routines')}</H5>
          <P2 type="secondary">{routines.length}</P2>
        </FlexRow>
        {routines.length > 7 && (
          <SecondaryButton
            title={t('global.seeAll')}
            onClick={() => {
              modal.openRoutineListModal({ routines: routines });
            }}
          />
        )}
      </FlexRow>
      <View style={{ gap: Spacing.sm }}>
        {routines.slice(0, 7).map(r => (
          <Link key={r.short_id} href={`/routine/${r.short_id}`}>
            <RoutineCardContainer>
              <P2>{r.title}</P2>
            </RoutineCardContainer>
          </Link>
        ))}
      </View>
    </Card>
  );
};

const RoutinesRow = styled(FlexRow)`
  overflow-x: scroll;
  gap: ${Spacing.sm}px;
  padding: ${Spacing.md}px;

  /* Hide the scroll indicator */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none; /* Chrome */
  }
`;

export const MobileRoutineCard = ({ routines }: { routines: RoutineMetadata[] }) => {
  return (
    <Card>
      <FlexRow style={{ padding: Spacing.md, paddingBottom: 0, justifyContent: 'space-between' }}>
        <FlexRow style={{ gap: Spacing.sm }}>
          <P1>{t('global.routines')}</P1>
          <P2>{routines.length}</P2>
        </FlexRow>
        {routines.length > 7 && (
          <SecondaryButton
            title={t('global.seeAll')}
            onClick={() => {
              modal.openRoutineListModal({ routines: routines });
            }}
          />
        )}
      </FlexRow>
      <RoutinesRow>
        {routines.slice(0, 7).map(r => (
          <Link key={r.short_id} href={`/routine/${r.short_id}`}>
            <Card
              style={{
                padding: Spacing.md,
                minHeight: 40,
                minWidth: 100,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <P2>{r.title}</P2>
            </Card>
          </Link>
        ))}
      </RoutinesRow>
    </Card>
  );
};
